import React from "react";

export default ({ title, color = {} }) => (
  <div style={{ color }} className="text-lg md:text-2xl font-semibold">
    {title}
  </div>
);
